import { errorAction, successfulAction } from '@shared/actions';
import { STATUS_CODE } from '@shared/constants';
import getProductsRequireValidate from '@services/cart/getProductsRequireValidate';

import { AGE_VALIDATION_PRODUCTS as type } from '@core/reducers/cart/actionTypes';

const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchProductsRequireValidate = (productsIds, shopId) => async (
  dispatch,
  _,
  axios,
) => {
  try {
    dispatch({ type });

    if (productsIds && shopId) {
      const { success, data } = await getProductsRequireValidate({
        axios,
        products: productsIds,
        vendor: shopId,
      });

      if (success) {
        const products = [];
        if (data?.products?.length > 0) {
          data.products.map(p => {
            if (p.need_reliable_age_validation) {
              products.push(parseInt(p.id, 10));
            }
          });
        }

        dispatch(
          successfulAction({
            type,
            payload: products,
          }),
        );
        return data.additional_data;
      }
      return false;
    }
  } catch (error) {
    dispatch(
      errorAction({
        type,
        error,
        errorCode,
      }),
    );
  }
  return false;
};

export default fetchProductsRequireValidate;
